export const subscription = {
  titles: {
    subscription: "الاشتراك",
    freeTrial: "الفترة التجريبية المجانية",
    expired: "منتهٍ",
  },

  status: {
    active: "نشط",
    canceled: "ملغى",
    trialAccess: "الفترة التجريبية المجانية",
    expiredAccess: "انتهت صلاحية الوصول",
  },

  notices: {
    activeDesc: "أدِر تفاصيل اشتراكك وخيارات الترقية.",
    canceledDesc:
      "تم إلغاء اشتراكك. ستحتفظ بإمكانية الوصول حتى تاريخ الانتهاء.",
    trialDesc: "يمكنك الوصول إلى ميزات النظام حتى تاريخ انتهاء الصلاحية.",
    expiredDesc:
      "انتهت فترتك التجريبية. اشترك لمواصلة استخدام الخدمة.",
    upgradeHint:
      "لا تفقد إمكانية الوصول إلى الميزات المتقدمة، رقِّ اشتراكك الآن",
    expiredHint:
      "انتهت صلاحية وصولك. اشترك لمواصلة استخدام جميع الميزات",
    needFullAccess: "هل تحتاج إلى وصول كامل؟",
    choosePlan: "اختر خطة تناسبك",
  },

  labels: {
    planActive: "الخطة النشطة",
    stateNow: "الحالة الحالية",
    trialPeriod: "الفترة التجريبية",
    periodExpired: "الفترة المنتهية",
    summary: "ملخص الاشتراك",
    timeLeft: "الوقت المتبقي",
    trialExpiresIn: "تنتهي فترتك التجريبية المجانية خلال {days} يوم",
    expirationDate: "تاريخ الانتهاء",
    nextRenewal: "التجديد التالي",
    accessUntil: "الوصول متاح حتى",
    perUnit: "/ لكل {unit}",
    unitRoom: "غرفة",
    unitRoomMultiple: "غرف متعددة",
    unitApartment: "شقة",
    unitVilla: "فيلا",
    unitCamping: "تخييم",
    unitLodging: "مسكن",
    annualPlan: "الخطة السنوية",
    monthlyPlan: "الخطة الشهرية",
  },

  actions: {
    addUnit: "إضافة {unitLabel}",
    manageSubAndPayment: "إدارة الاشتراك وطريقة الدفع",
    processing: "جارٍ المعالجة...",
    subscribeNow: "اشترك الآن",
    chooseAPlan: "اختر خطة",
    goToSubscriptionPage: "الانتقال إلى الخطط",
  },

  confirmCancel: {
    title: "إلغاء الاشتراك؟",
    text: "إذا ألغيت الاشتراك، ستفقد إمكانية الوصول إلى خدماتك.",
    confirm: "نعم، ألغِ",
    cancel: "لا",
  },

  formats: {
    priceTotalHTML: "{price}",
    dateDDMMYYYY: "{date}",
  },

  modal: {
    title: 'تم تفعيل الاشتراك!',
    details: "تفاصيل الاشتراك",
    welcomeTitle: "مرحبًا بك في WA Checkin {plan}!",
    welcomeBody:
      "أصبح لديك الآن وصول كامل إلى أدوات تسجيل الوصول عبر WhatsApp، ومزامنة OTA، وروبوت المحادثة بالذكاء الاصطناعي، والأتمتة والمزيد.",
    feature1: {
      title: "إدارة الأسعار والإتاحة",
      desc: "عدِّل أسعارك بسهولة وتحكّم في الإشغال في الوقت الفعلي، كل ذلك من مكان واحد.",
    },
    feature2: {
      title: "احصل على حجوزات مباشرة",
      desc: "من موقعك الإلكتروني الخاص، يمكن للنزلاء الحجز مباشرةً دون المرور عبر منصات OTA.",
    },
    schedule: {
      help: "احجز مكالمة فيديو مجانية وسنساعدك في إعداد كل شيء.",
      cta: "حجز مكالمة فيديو",
    },
  },

  sectionPlans: {
    title: "قائمة الخطط",
    confirm: {
      header: "تأكيد ترقية الخطة",
      loadingMsg: "جارٍ تحديث خطتك، يُرجى الانتظار.",
      body: "أنت على وشك تغيير خطة حسابك إلى {plan}.",
    },
    actions: {
      cancel: "إلغاء",
      confirmUpgrade: "تأكيد الترقية",
      goToBilling: "الانتقال إلى طرق الدفع",
      accept: "حسنًا",
      updateSubscription: "تحديث الاشتراك", // NEW
    },
    success: {
      title: "تم بنجاح",
      body: "تم تحديث اشتراكك.",
    },
    errors: {
      processTitle: "خطأ في معالجة الطلب",
      unknownUpdate: "حدث خطأ غير معروف أثناء تحديث الاشتراك.",
      genericTitle: "خطأ",
      genericBody: "تعذّر تحديث الاشتراك.",
    },
  },

  plans: {
    features: {
      installation: "إعداد مخصّص بمساعدة خبير",
      fastSupport: "دعم سريع عبر البريد الإلكتروني والدردشة والهاتف",
      whatsappCheckin: "تسجيل الوصول عبر WhatsApp",
      linkEmailCheckin: "تسجيل الوصول عبر رابط / بريد إلكتروني",
      welcomeMessage: "رسالة ترحيب عبر WhatsApp والبريد الإلكتروني",
      digitalSignature: "التوقيع الرقمي على السياسات",
      idScanner: "ماسح بطاقة الهوية/جواز السفر",
      sesHospedajesSend: "إرسال تلقائي لبلاغات الشرطة",
      reviewLink: "إرسال رابط تقييم Google بعد تسجيل المغادرة",
      smartLocks: "الاتصال بأقفالك الذكية",
      channelManager1: "مدير القنوات (اتصال بمنصة OTA واحدة)",

      includesLite: "كل ما في خطة Lite",
      selfieVerification: "التحقق من هوية النزيل عند تسجيل الوصول بصورة ذاتية",
      unifiedInbox: "صندوق وارد موحّد",
      upsellServices: "عرض الخدمات والتجارب عبر WhatsApp",
      paymentLinks: "تحصيل مدفوعات النزلاء (رابط دفع بالبطاقة)",
      websiteBookings: "موقع للحجوزات بتقويم متزامن",
      channelManagerUnified: "مدير القنوات (تقاويم موحّدة، أكثر من 100 منصة OTA)",
      channelManagerCentralPrices:
        "مدير القنوات (إدارة مركزية للأسعار)",
      guestSupportOption: "إمكانية التعاقد على دعم النزلاء",

      includesStandard: "كل ما في خطة Standard",
      centralizedPriceManager: "مدير أسعار مركزي",
      aiChatbot: "روبوت محادثة WhatsApp بالذكاء الاصطناعي (الأسئلة الشائعة والأتمتة)",
      googleVacationRentals: "تكامل مع Google Vacation Rentals",
      whatsappReminders: "تذكيرات WhatsApp للنزلاء",
      eInvoicingSoon: "الفوترة الإلكترونية (قريبًا)",
      prioritySupport: "دعم ذو أولوية",
    },
  },

  planCard: {
    perSlash: "/لكل", // separator "/per {unit}"
    infoTitle: "تفاصيل الخطة",
    update: "تحديث",
    subscribe: "اشترك",
    currentPlan: "الخطة الحالية",
    byApartment: "لكل شقة",
    byVilla: "لكل فيلا",
    byCamping: "لكل موقع تخييم",
    byRoom: "لكل غرفة",
    byUnit: "لكل وحدة",
  },

  services: {
    title: "خدمات إضافية",
    ctaComingSoon: "قريبًا",
    guestSupport: {
      title: "خدمة دعم النزلاء",
      subtitle: "نتولّى نيابةً عنك رسائل WhatsApp والمكالمات الهاتفية من نزلائك.",
      desc: "نساعدهم في تسجيل الوصول، ونجيب عن أسئلتهم، ونتولّى أيضًا مكالمات الحجز المباشر. تسترخي أنت بينما يحظون بتجربة 10/10 من أول تواصل.",
    },
    chatbot: {
      title: "روبوت المحادثة بالذكاء الاصطناعي",
      activeService: "خدمة نشطة",
      desc: "أضِف خدمة روبوت المحادثة بالذكاء الاصطناعي وأتمِت استفسارات نزلائك بسرعة وكفاءة.",
      activateCta: "تفعيل الخدمة",
      confirm: {
        header: "تأكيد التفعيل",
        loadingMsg: "جارٍ تفعيل خدمة روبوت المحادثة، يُرجى الانتظار.",
        body: "أنت على وشك تفعيل خدمة روبوت المحادثة بالذكاء الاصطناعي لعقاراتك البالغ عددها {units}.",
      },
      discount: {
        applied: "الخصم المطبَّق:",
        couponFallback: "قسيمة",
      },
      pricing: {
        unitPrice: "سعر الوحدة:",
        quantity: "الكمية:",
        totalToPay: "الإجمالي المستحق:",
      },
    },
  },

  invoices: {
    title: "الفواتير والإيصالات",
    created: "تاريخ الإنشاء",
    status: "الحالة",
    amount: "المبلغ",
    paid: "مدفوعة",
    unpaid: "غير مدفوعة",
    viewInvoice: "عرض الفاتورة",
    empty: "ليس لديك أي فواتير بعد.",
  },

  updateModal: {
    header: "إضافة {unitLabel}",
    body: "أضِف عدد {unitLabelPlural} إلى اشتراكك.",
    pricing: {
      discountApplied: "الخصم المطبَّق على الاشتراك:",
      unitPrice: "سعر الوحدة:",
      quantity: "الكمية:",
      totalNewUnits: "إجمالي الوحدات الجديدة:",
      newSubscriptionTotal: "القيمة الإجمالية الجديدة للاشتراك:",
    },
    prorationNote:
      "يتم احتساب تغييرات الاشتراك بالتناسب بناءً على الأيام المتبقية في الفترة الحالية. سيُطبَّق الرسم الكامل الشهر المقبل.",
  },

  page: {
    findRightPlan: "اعثر على الخطة المناسبة لك",
    enterAmount: "أدخِل الكمية",
    numberOf: "عدد {unit}"
  },
  billing: {
    title: "اختر فترة الفوترة",
    subtitle: "اختر طريقة الدفع التي تريدها",
    monthly: "شهريًا",
    annual: "سنويًا",
    discountShort: "−{percent}%",
  },
};
